export default __webpack_public_path__ + "static/media/monkey19.6196306e.jpeg";